import { ReactElement } from 'react';

import { PlainHtmlContainer } from '@cashier/cashier-ui';

import styles from './styles.module.scss';

interface PaymentMethodDescriptionProps {
  content: string;
}

export const Description = ({
  content,
}: PaymentMethodDescriptionProps): ReactElement => {
  return (
    <PlainHtmlContainer
      className={styles.text}
      content={content}
      config={{
        ADD_ATTR: ['target', 'rel'],
      }}
    />
  );
};
